import { SxProps } from '@mui/material';

export const radioGroupBoxSx = (overrideSx?: SxProps): SxProps => ({
  mt: '12px',
  ...overrideSx,
});
